// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"047b328c826749892527","293":"b708c36c0271cd4bddbf","518":"b0399f15d1ee1d1ea997","779":"ab3a83f1aa0b13fe793e"}[chunkId] + ".js";
};